import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Icon, Select } from 'semantic-ui-react';

import _debounce from 'lodash/debounce';
import _isEmpty from 'lodash/isEmpty';

import {
  appendSearchQueryToOptions,
  createStyleRuleSearchOptions,
} from './LocalStyleRuleSearch.utils';
import { StyleRuleConfigurationsPropType } from '../../types';
import {
  DEBOUNCED_SEARCH_QUERY_TIME,
  MAX_OPTIONS,
} from '../GlobalStyleRuleSearch/GlobalStyleRuleSearch.constants';

import './LocalStyleRuleSearch.scss';

const propTypes = {
  styleRuleConfigurations: StyleRuleConfigurationsPropType.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSelectStyleRule: PropTypes.func,
  onSearchStyleRule: PropTypes.func,
  maxOptions: PropTypes.number,
};

const defaultProps = {
  onSelectStyleRule: () => {},
  onSearchStyleRule: () => {},
  maxOptions: MAX_OPTIONS,
};

export default function LocalStyleRuleSearch({
  styleRuleConfigurations,
  searchQuery,
  onSelectStyleRule,
  onSearchStyleRule,
  maxOptions,
}) {
  const [selectedResult, setSelectedResult] = useState(null);
  const [loading, setLoading] = useState(false);

  function addImageToOptions(options) {
    return options.map(({ icon, ...rest }) => ({ ...rest, image: <Icon name="at" /> }));
  }

  const allOptions = createStyleRuleSearchOptions(styleRuleConfigurations);
  const options = appendSearchQueryToOptions(
    addImageToOptions(allOptions).slice(0, maxOptions),
    searchQuery,
  );

  function onSearchQueryChange(e, { searchQuery: nextSearchQuery }) {
    setLoading(true);

    setSelectedResult(null);
    if (onSearchStyleRule) {
      onSearchStyleRule(nextSearchQuery);
    }

    setLoading(false);
  }

  function onSelectOption(e, { value }) {
    setSelectedResult(value);

    if (onSelectStyleRule) {
      onSelectStyleRule(value);
    }
  }

  useEffect(() => {
    if (_isEmpty(searchQuery)) {
      setSelectedResult(null);
    }
  }, [searchQuery]);

  return (
    <Select
      className="local-style-rule-search"
      placeholder="Local search..."
      options={options}
      onChange={onSelectOption}
      onSearchChange={_debounce(onSearchQueryChange, DEBOUNCED_SEARCH_QUERY_TIME)}
      value={selectedResult}
      selection
      fluid
      clearable
      loading={loading}
      search={() => options}
      selectOnNavigation={false}
    />
  );
}

LocalStyleRuleSearch.propTypes = propTypes;
LocalStyleRuleSearch.defaultProps = defaultProps;
